import {
  RouterProvider,
  createMemoryHistory,
  createRootRoute,
  createRouter,
} from '@tanstack/react-router';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// A minimal router is required so TanStack Router hooks (e.g. useBlocker) have context.
// The external app reads URL params from window.location directly, so memory history
// has no effect on its behavior.
const rootRoute = createRootRoute({ component: App });
const externalRouter = createRouter({
  routeTree: rootRoute,
  history: createMemoryHistory(),
});

(async () => {
  const LaunchDarklyProvider = await asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_KEY,
    options: {
      bootstrap: 'localStorage',
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  });

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root element not found');
  }
  const root = createRoot(container);
  root.render(
    <LaunchDarklyProvider>
      <RouterProvider router={externalRouter} />
    </LaunchDarklyProvider>,
  );
})();
